import styled, { css } from 'styled-components';

export interface Props {
	showModal: boolean;
}

export const ModalWrapper = styled.div<Pick<Props, 'showModal'>>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	padding: 20px;
	opacity: 0;
	transition: opacity 0.2s ease-in-out;
	z-index: -1;
	pointer-events: none;
	overflow-y: scroll;

	${({ showModal }) =>
		showModal &&
		css`
			opacity: 1;
			z-index: 1;
			pointer-events: auto;
		`}
`;

export const ModalContainer = styled.div`
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 450px;
`;

export const Modal = styled.div`
	max-width: 430px;
  width: 100%;
  border-radius: 5px;
  background: #FFF;
  padding 20px 20px 7px 20px;
	margin: auto;
`;

export const Info = styled.p`
	color: rgba(0, 0, 0, 0.5);
	font-size: 16px;
	font-weight: 400;
	line-height: 20px;
`;

export const Info2 = styled.p`
	color: #000;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
	margin-top: 20px;
`;

export const Info3 = styled.p`
	color: #6d25a8;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
	margin-top: 20px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: centerl;
	gap: 10px;
	margin-top: 20px;
`;

export const Button = styled.button`
	height: 50px;
	width: 100%;
	border-radius: 5px;
	background: linear-gradient(225deg, #542285 0%, #226 100%);
	backdrop-filter: blur(4.53046989440918px);
	color: #fff;
	text-align: center;
	font-size: 20px;
	font-weight: 500;
	line-height: normal;
	letter-spacing: 0.35px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 16px;
	margin-bottom: 9px;

	&:active {
		opacity: 0.5;
	}

	&:disabled {
		opacity: 0.5;
	}
`;

export const Label = styled.p`
	color: rgba(0, 0, 0, 0.5);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 20px;
`;
